import React from "react";
import { Popover } from "@clarkinc/zest-design-system";
import { cls } from "cls";
import { ClientOnly } from "@wss/react";
export default function SpecialOrderInfo() {
  return <div className={cls("relative", "flex", "w-full", "max-w-sm", "mb-4", "bg-white")} data-sentry-component="SpecialOrderInfo" data-sentry-source-file="SpecialOrderInfo.tsx">
      <img className={cls("w-10", "h-10", "m-auto", "mr-2")} src="/uploads/design/2022/7/icon_shipping.svg" alt="" />
      <div>
        <p className="m-0 text-sm font-bold">Special Order Shipping</p>
        <p className="m-0 inline">
          An estimated delivery date will be provided after placing the order
        </p>
        <ClientOnly data-sentry-element="ClientOnly" data-sentry-source-file="SpecialOrderInfo.tsx">
          <Popover className="inline" data-sentry-element="Popover" data-sentry-source-file="SpecialOrderInfo.tsx">
            <Popover.Trigger contentId="special-order-shipping-popover" className="more-info popover-dismiss ml-1 text-sm leading-4 text-green-500 hover:text-green-700" data-sentry-element="unknown" data-sentry-source-file="SpecialOrderInfo.tsx">
              <i className="icon-question" aria-hidden="true" />
              <span className="sr-only">Estimated shipping time</span>
            </Popover.Trigger>
            <Popover.Content id="special-order-shipping-popover" title="Estimated Shipping Time" placement="top" data-sentry-element="unknown" data-sentry-source-file="SpecialOrderInfo.tsx">
              Item is not normally stocked in our warehouses. These items may be
              shipped directly to you from the manufacturer or brought into our
              warehouse with our next stock order from the manufacturer and then
              shipped to you. This can take up to several weeks to arrive to
              you. An estimated delivery date will be provided after placing the
              order. Please note – we are not always able to cancel or return
              special ordered items. Contact us if you have any questions about
              this item before placing your order.
            </Popover.Content>
          </Popover>
        </ClientOnly>
      </div>
    </div>;
}